import { render } from "./Especialidad.vue?vue&type=template&id=5dc3feda&scoped=true"
import script from "./Especialidad.vue?vue&type=script&lang=js"
export * from "./Especialidad.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=5dc3feda&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc3feda"]])

export default __exports__